export default "__VITE_ASSET__D$FmcI93__"